import React from "react";
import { useAuthContext } from "../../../context/auth";

const DIFFICULTY_COLORS = {
  easy: "#53CAF5",
  normal: "rgba(246,183,49,0.7)",
  hard: "rgba(255,87,87,0.7)",
};

const DID_STATION_MAP: Record<string, [number, number]> = {
  L1: [0, 1],
  L6: [2, 3],
  R1: [4, 5],
  R6: [6, 7],
};

function HiluxStationPortrait() {
  const { hiluxProgram, did } = useAuthContext();

  if (!hiluxProgram || !did) return null;

  const indices = DID_STATION_MAP[did];
  if (!indices) return null;

  const stations = indices
    .filter((i) => i < hiluxProgram.stations.length)
    .map((i) => ({ station: hiluxProgram.stations[i], idx: i }));

  return (
    <div className="flex flex-col w-full h-full bg-white">
      {stations.map(({ station, idx }) => (
        <React.Fragment key={idx}>
          <div className="bg-[#020A1F] border-b border-[#EEEEF6] h-[160px] w-full flex items-center justify-between px-[70px] shrink-0">
            <p className="text-[64px] font-bold text-white uppercase leading-[160px]">
              Station {idx + 1}
            </p>
            <img
              src="/hyrox-logo.png"
              alt="HYROX"
              className="h-[100px] w-[201px] object-contain"
            />
          </div>
          <div className="flex-1 min-h-0 relative w-full">
            <div className="absolute top-[30px] left-[30px] flex flex-col gap-[20px] z-10">
              {(
                [
                  { label: "Easy", text: station.easyText, color: DIFFICULTY_COLORS.easy },
                  { label: "Normal", text: station.normalText, color: DIFFICULTY_COLORS.normal },
                  { label: "Hard", text: station.hardText, color: DIFFICULTY_COLORS.hard },
                ] as const
              ).map((diff) => (
                <div key={diff.label} className="flex gap-[20px] items-start">
                  <span
                    className="text-[48px] font-medium tracking-[-4.8px]"
                    style={{ color: diff.color }}
                  >
                    {diff.label}
                  </span>
                  <span className="text-[48px] font-medium text-[rgba(2,10,31,0.7)] uppercase">
                    {diff.text}
                  </span>
                </div>
              ))}
            </div>
            {station.movement?.video && (
              <video
                className="absolute inset-0 w-full h-full object-cover"
                loop
                muted
                autoPlay
                playsInline
                src={station.movement.video}
              />
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default HiluxStationPortrait;
